<bn-loading-overlay></bn-loading-overlay>
<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>

<h5>Recuperações de Crédito</h5>
<div class="container" *ngIf="valoresPesquisaForm; else carregando">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="mb-3 row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary no-margin" type="button" [routerLink]="['/recuperacoes-credito/cadastro']" placement="bottom"
          ngbTooltip="Tela para envio de recuperação de crédito individual." [disabled]="!podeEnviarRecCredito"><i class="fa fa-file-signature">
          </i> Recuperação individual</button>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar(false, true)" (click)="buscar(false, true)"
        [disabled]="!pesquisaForm.valid">Pesquisar</button>
      </div>
    </div>

    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <select  id="agenteFinanceiro" class="form-select" [compareWith]="compararPorId" formControlName="agenteFinanceiro">
          <option [ngValue]=null>Todos</option>
          <option *ngFor="let item of agentesFinanceiros"
                  [ngValue]="item">{{ item.nome }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataEnvioInicio">Data de envio inicial:</label>
        <bn-datepicker name="dataEnvioInicio" idInput="dataEnvioInicio" formControlName="dataEnvioInicio" >
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-3">
          <label class="form-label" for="dataEnvioFim">Data de envio final:</label>
          <bn-datepicker name="dataEnvioFim" idInput="dataEnvioFim" formControlName="dataEnvioFim">
          </bn-datepicker>
      </div>
    </div>

    <div class="row">
      <div class="col-md-2">
        <label class="form-label" for="idProtocoloArquivo">Id. de protocolo: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="O identificador de protocolo do arquivo de recuperação enviado"></i></label>
        <input type="text" class="form-control" formControlName="idProtocoloArquivo">
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="estado">Estado:</label>
        <select id="estado" class="form-select" [compareWith]="compararPorId" formControlName="estado">
          <option [ngValue]=null>Todos</option>
          <option *ngFor="let item of estados"
                  [ngValue]="item">{{item.nome }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="sistema">Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
              ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i>
        </label>
        <select id="sistema" class="form-select" [compareWith]="compararPorId" formControlName="sistema">
          <option [ngValue]=null>Todos</option>
          <option [ngValue]="'CL'">Crédito Livre</option>
          <option [ngValue]="'15'">15 - Contratos FINAME</option>
          <option [ngValue]="'89'">89 - Contratos BNDES</option>
        </select>
      </div>
      <div class="bn-form-group col-md-2">
        <label class="form-label">Id. ext. operação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
        </label>
        <input class="form-control" formControlName="idExternoOperacao">
      </div>

      <div class="bn-form-group col-md-2">
        <label class="form-label">Contrato: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
        </label>
        <input class="form-control" formControlName="contrato">
      </div>
    </div>
    <div class="row">
      <div class="bn-form-group col-md-2">
        <label class="form-label" for="idCobranca">Id. recuperação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Identificador da recuperação de crédito gravada no sistema"></i></label>
        <input type="text" class="form-control" formControlName="idRecuperacao">
      </div>
      <div class="bn-form-group col-md-2">
        <label class="form-label" for="idCobranca">Id. cobrança: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="O identificador da cobrança em que a recuperação foi incluída"></i></label>
        <input type="text" class="form-control" formControlName="idCobranca">
      </div>
    </div>
  </form>
</div>

<app-recuperacao-credito-listagem
  [recuperacoesCredito]="recuperacoesCredito"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  [ehAgenteFinanceiro]="ehAgenteFinanceiro"
  [mostrarDatasValores]="true"
  *ngIf="pesquisado"
  [hidden]="esconderPesquisa"
  (aoMudarPagina)="mudancaPagina($event)"
  (aoExportarRecuperacoes)="exportarRecuperacoes()">
</app-recuperacao-credito-listagem>